var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 23,
    viewBox: "0 0 31 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000189364 16.8667C-0.000189068 20.2533 2.74653 23 6.13314 23C9.51976 23 12.2665 20.2533 12.2665 16.8667C12.2665 13.4801 9.51976 10.7333 6.13314 10.7333C5.11897 10.7333 4.18327 10.999 3.33813 11.4336C4.42474 6.6525 8.70479 3.06667 13.8119 3.06667C14.657 3.06667 15.3452 2.37848 15.3452 1.53334C15.3452 0.688192 14.657 3.87486e-06 13.8119 3.94875e-06C6.19351 4.61476e-06 -0.000190297 6.19371 -0.000189631 13.8121L-0.000189364 16.8667Z",
    fill: "#1E334E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3211 16.8667C15.3211 20.2533 18.0678 23 21.4544 23C24.841 23 27.5878 20.2533 27.5878 16.8667C27.5878 13.4801 24.841 10.7333 21.4544 10.7333C20.4403 10.7333 19.5046 10.999 18.6594 11.4336C19.746 6.6525 24.0261 3.06667 29.1332 3.06667C29.9783 3.06667 30.6665 2.37848 30.6665 1.53334C30.6665 0.688192 29.9783 3.87486e-06 29.1332 3.94875e-06C21.5148 4.61476e-06 15.3211 6.19371 15.3211 13.8121L15.3211 16.8667Z",
    fill: "#1E334E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteLeft);
export default __webpack_public_path__ + "static/media/quote-left.ea9e1d4c3fea4af51f54a2683409e1d0.svg";
export { ForwardRef as ReactComponent };